import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuildingUser } from "@fortawesome/pro-regular-svg-icons/faBuildingUser";

export const BuildingUser: FC<JSX.IntrinsicAttributes> = (props) => (
    <FontAwesomeIcon icon={faBuildingUser} {...props} />
);
